const commonUrl = "api/v1"

const apiEndPoints = {
    logout: `${commonUrl}/ekutir/user/auth/logout`,

    countryMetaData: `${commonUrl}/generic/countryMetadata`,
    solutionMetaData: `${commonUrl}/ekutir/initiativeEcoSystem/metadata`,

    userTypeCreateOrUpdate: `${commonUrl}/ekutir/master`,
    getAlluserType: `${commonUrl}/ekutir/master`,
    userTypeGetById: `${commonUrl}/ekutir/master`,
    deleteUserType: `${commonUrl}/ekutir/master`,
    patchApi: `${commonUrl}/ekutir/master`,

    subscriptionCreateOrUpdate: `${commonUrl}/ekutir/master/subscription`,
    getAllSubscription: `${commonUrl}/ekutir/master/subscription`,
    subscriptionGetById: `${commonUrl}/ekutir/master/subscription`,
    deleteSubscription: `${commonUrl}/ekutir/master/subscription`,
    subscriptionPatchApi: `${commonUrl}/ekutir/master/subscription`,
    subscriptionMetaData: `${commonUrl}/ekutir/master/subscription`,

    initiativeCreateOrUpdate: `${commonUrl}/ekutir/initiativeEcoSystem`,
    getAllInitiative: `${commonUrl}/ekutir/initiativeEcoSystem`,
    initiativeGetById: `${commonUrl}/ekutir/initiativeEcoSystem`,
    deleteInitiative: `${commonUrl}/ekutir/initiativeEcoSystem`,
    initiativePatchApi: `${commonUrl}/ekutir/initiativeEcoSystem`,

    getAllUserManagement: `${commonUrl}/ekutir/userManagement`,
    userManagementGetById: `${commonUrl}/ekutir/userManagement`,
    userPatchApi: `${commonUrl}/ekutir/userManagement`,


    countryManagementCreateOrUpdate: `${commonUrl}/ekutir/master/countryManagement`,
    getAllcountryManagement: `${commonUrl}/ekutir/master/countryManagement`,
    countryManagementGetById: `${commonUrl}/ekutir/master/countryManagement`,
    deleteCountryManagement: `${commonUrl}/ekutir/master/countryManagement`,
    countryManagementMetaData: `${commonUrl}/ekutir/master/countryManagement/metadata`,

    ecosytemIntegatorCreateOrUpdate: `${commonUrl}/ekutir/ecosytemIntegrator`,
    getAllEcosytemIntegator: `${commonUrl}/ekutir/ecosytemIntegrator`,
    ecosytemIntegatorGetById: `${commonUrl}/ekutir/ecosytemIntegrator`,
    deleteEcosytemIntegator: `${commonUrl}/ekutir/ecosytemIntegrator`,
    ecosytemIntegatorMetaData: `${commonUrl}/ekutir/ecosytemIntegrator/metadata`,
    
};

export default apiEndPoints;